import React, { useEffect, useState } from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import googleplay from '../../assets/images/googleplay.png';
import appstore from '../../assets/images/appstore.png';
import './Footer.scss';
import { get, isIosApp, isWebView } from '../../Utilities';
import { getAppLanguage } from '../../redux/reducers/clientUserId.reducer';
import { connect } from 'react-redux';
import { getCurrentBranding } from '../../redux/reducers/branding.reducer';

const Footer = (props) => {
  const { branding: {branding}, dashboardDesign, clientId, appLanguage = 1, background } = props;
  const currentYear = new Date().getFullYear();
  const [isFaqAdded, setIsFaqAdded] = useState(false);

  useEffect(() => {
    get({client_id: clientId}, '/areFaqsAdded').then(res => {
      if(res && res.success) {
        setIsFaqAdded(res.result);
      }
    })
  }, []);

  return (
    <footer
      className='footerCustom'
      style={dashboardDesign ? { borderRadius: '12px', background: 'var(--lightest-blue)' } : background ? {background} : {}}
    >
      <div className='containerFooter'>
        <div className={`row g-4 ${dashboardDesign ? 'px-0 px-md-4' : 'px-4'} py-5`}>
          
          <div className='col-lg-3 col-md-6'>
            <div className='footer-section'>
              {clientId !== 1104 && (
                <div className='footer-logo mb-3'>
                  <div className='logo-circle'>
                    <span className='logo-text'>
                      <img
                        src={branding?.client_logo}
                        style={{ width: '70px', aspectRatio: '1', borderRadius: '100%' }}
                      />
                    </span>
                  </div>
                </div>
              )}
              <h4 className={dashboardDesign ? 'company-name dashboard-color' : 'company-name'}>
                {branding.language_name ? (branding.language_name[`${appLanguage}`] || branding.language_name[`1`]) : branding.client_name}
              </h4>
              <div
                className={
                  dashboardDesign ? 'social-links mt-4 dashboard-color' : 'social-links mt-4'
                }
              >
                {Boolean(branding.facebook_link) && (
                  <a
                    onClick={() => {
                      if (isWebView) {
                        window.location.href = branding.facebook_link;
                      }
                    }}
                    href={branding.facebook_link}
                    target='_blank'
                    className='social-icon facebook'
                  >
                    <i className='fab fa-facebook-f'></i>
                  </a>
                )}
                {Boolean(branding.instagram_link) && (
                  <a
                    onClick={() => {
                      if (isWebView) {
                        window.location.href = branding.instagram_link;
                      }
                    }}
                    href={branding.instagram_link}
                    target='_blank'
                    className='social-icon instagram'
                  >
                    <i className='fab fa-instagram'></i>
                  </a>
                )}
                {Boolean(branding.twitter_link) && (
                  <a
                    onClick={() => {
                      if (isWebView) {
                        window.location.href = branding.twitter_link;
                      }
                    }}
                    href={branding.twitter_link}
                    target='_blank'
                    className='social-icon twitter'
                  >
                    <i className='fab fa-twitter'></i>
                  </a>
                )}
                {Boolean(branding.youtube_link) && (
                  <a
                    onClick={() => {
                      if (isWebView) {
                        window.location.href = branding.youtube_link;
                      }
                    }}
                    href={branding.youtube_link}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='social-icon youtube'
                  >
                    <i className='fab fa-youtube'></i>
                  </a>
                )}
                {Boolean(branding.linkedin_link) && (
                  <a
                    onClick={() => {
                      if (isWebView) {
                        window.location.href = branding.linkedin_link;
                      }
                    }}
                    href={branding.linkedin_link}
                    target='_blank'
                    className='social-icon linkedin'
                  >
                    <i className='fab fa-linkedin-in'></i>
                  </a>
                )}
                {Boolean(branding.whatsapp_link) && (
                  <a
                    onClick={() => {
                      if (isWebView) {
                        window.location.href = branding.whatsapp_link;
                      }
                    }}
                    href={branding.whatsapp_link}
                    target='_blank'
                    className='social-icon whatsapp'
                  >
                    <i className='fab fa-whatsapp'></i>
                  </a>
                )}
                {Boolean(branding.telegram_link) && (
                  <a
                    onClick={() => {
                      if (isWebView) {
                        window.location.href = branding.telegram_link;
                      }
                    }}
                    href={branding.telegram_link}
                    target='_blank'
                    className='social-icon telegram'
                  >
                    <i className='fab fa-telegram-plane'></i>
                  </a>
                )}
              </div>
            </div>
          </div>

          {/* Contact Info Section */}
          {clientId !== 1104 && (
            <div className='col-lg-3 col-md-6'>
              <div className='footer-section'>
                <h5 className={dashboardDesign ? 'footer-title dashboard-color' : 'footer-title'}>
                  Contact Us
                </h5>
                <ul className={dashboardDesign ? 'contact-list dashboard-color' : 'contact-list'}>
                  {Boolean(branding.client_address) && (
                    <li>
                      <MapPin size={18} />
                      <span>{branding.client_address}</span>
                    </li>
                  )}
                  {Boolean(branding.client_contact) && (
                    <li>
                      <Phone size={18} />
                      <a
                        onClick={() => {
                          if (isWebView) {
                            window.location.href = `tel:+91${branding.client_contact}`;
                          }
                        }}
                        href={`tel:+91${branding.client_contact}`}
                      >
                        +91-{branding.client_contact}
                      </a>
                    </li>
                  )}
                  {Boolean(branding.client_email) && (
                    <li>
                      <Mail size={18} />
                      <a
                        onClick={() => {
                          if (isWebView) {
                            window.location.href = `mailto:${branding.client_email}`;
                          }
                        }}
                        href={`mailto:${branding.client_email}`}
                      >
                        {branding.client_email}
                      </a>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          )}

          {/* Quick Links Section */}
          {clientId !== 1104 && (
            <div className='col-lg-3 col-md-6'>
              <div className='footer-section'>
                <h5 className={dashboardDesign ? 'footer-title dashboard-color' : 'footer-title'}>
                  Legal
                </h5>
                <ul className={dashboardDesign ? 'footer-links dashboard-color' : 'footer-links'}>
                  <li>
                    <Link to='/privacypolicy'>Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to='/termsandconditions'>Terms & Conditions</Link>
                  </li>
                  <li>
                    <Link to='/refundpolicy'>Refund Policy</Link>
                  </li>
                   {isFaqAdded && <li>
                    <Link to='/faq'>FAQs</Link>
                  </li>}
                </ul>
              </div>
            </div>
          )}

          {/* Download App Section */}
          {!isWebView && !isIosApp && clientId !== 1104 && (
            <div className='col-lg-3 col-md-6'>
              <div className='footer-section'>
                <h5 className={dashboardDesign ? 'footer-title dashboard-color' : 'footer-title'}>
                  Download Our App
                </h5>
                <div className='app-buttons'>
                  <a
                    onClick={() => {
                      if (isWebView) {
                        window.location.href = branding.app_link;
                      }
                    }}
                    href={branding.app_link}
                    target='_blank'
                  >
                    <img width='180' src={googleplay} />
                  </a>
                </div>
                {branding.ios_link && (
                  <div className='app-buttons'>
                    <a onClick={() => {}} href={branding.ios_link} target='_blank'>
                      <img width='180' src={appstore} />
                    </a>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Copyright Section */}
        {!dashboardDesign && (
          <div className='footer-bottom'>
            <div className='row'>
              <div className='col-12'>
                <p
                  className={dashboardDesign ? 'copyright-text dashboard-color' : 'copyright-text'}
                >
                  © {currentYear}{' '}
                  {branding.language_name ? (branding.language_name[`${appLanguage}`] || branding.language_name[`1`]) : branding.client_name}. All
                  rights reserved.
                </p>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Font Awesome CDN for social icons */}
      <link
        rel='stylesheet'
        href='https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css'
      />
    </footer>
  );
};

const mapStateToProps = (state) => ({
  appLanguage: getAppLanguage(state),
  branding: getCurrentBranding(state)
});

export default connect(mapStateToProps)(Footer);
